import { render, staticRenderFns } from "./InspectionFeedback.vue?vue&type=template&id=2168564a&scoped=true&"
import script from "./InspectionFeedback.vue?vue&type=script&lang=js&"
export * from "./InspectionFeedback.vue?vue&type=script&lang=js&"
import style0 from "./InspectionFeedback.vue?vue&type=style&index=0&id=2168564a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2168564a",
  null
  
)

export default component.exports